<template>
  <v-dialog v-model="dialogOpen" width="500" persistent>
    <v-card>

      <v-card-title>Provisioning</v-card-title>

      <v-card-text>

        <v-row>
          <v-col cols="12" md="6">
            <DateSelect v-model="formData.expected_live_date" label="Expected live date"/>
          </v-col>

          <v-col cols="12" md="6" class="d-flex justify-start align-center">
            <v-switch v-model="formData.automated" label="Automated" hide-details class="mt-0 pt-0"></v-switch>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" :md="formData.new_line?'12':'6'">
            <v-checkbox v-model="formData.new_line" label="New line" hide-details dense class="mt-0" />
          </v-col>

          <template v-if="!formData.new_line">
            <v-col cols="12" md="6">
              <v-checkbox v-model="formData.auto_number" label="Auto number" hide-details dense class="mt-0" />
            </v-col>
          </template>
        </v-row>

        <v-row>
          <v-col>
            <v-checkbox v-model="formData.keep_existing_number" label="Keep existing number / Number selection" hide-details dense class="mt-0" />
          </v-col>
        </v-row>

        <template v-if="formData.keep_existing_number">          
          <v-row>
            <v-col>
              <v-text-field v-model="formData.line_to_be_taken_over" label="Line to be taken over" hide-details outlined dense />
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-text-field v-model="formData.old_line_postcode" label="Old line postcode" hide-details outlined dense />
            </v-col>
          </v-row>
        </template>

        <v-row>
          <v-col>
            <v-select v-model="formData.order_type" :items="getTelcoOrderTypes" :loading="getFetchTelcoOrderTypesLoading" :disabled="isNotConfirmedOrUpgrade||!hasUserGotRoles(['telco-provisioning'])" label="Order Type" dense outlined hide-details />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-select v-model="formData.line_supplier" :items="lineSuppliers" :disabled="isNotConfirmedOrUpgrade||!hasUserGotRoles(['telco-provisioning'])" label="Line supplier" dense outlined hide-details />
          </v-col>

          <v-col cols="12" md="6">
            <v-select v-model="formData.broadband_supplier" :items="broadbandSuppliers" :disabled="isNotConfirmedOrUpgrade||!hasUserGotRoles(['telco-provisioning'])" label="Broadband supplier" dense outlined hide-details />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-switch hide-details label="Two stage" v-model="formData.two_stage" class="mt-0" :disabled="!hasUserGotRoles(['telco-provisioning'])" />
          </v-col>

          <v-col cols="12" md="6">
            <DateSelect v-model="formData.second_stage_live_date" label="Second stage live date" :disabled="!formData.two_stage||!hasUserGotRoles(['telco-provisioning'])"/>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-switch hide-details label="Appointment" v-model="formData.installation_appt" class="mt-0" />
          </v-col>

          <v-col cols="12" md="6">
            <v-select v-model="formData.installation_appt_preferred_window" :items="appointmentTimes" label="Preferred engineer appointment time" dense outlined hide-details />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <DateSelect v-model="formData.installation_appt_date" label="Appointment date" :disabled="!hasUserGotRoles(['telco-provisioning'])"/>
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field v-model="formData.installation_appt_ref" label="Appointment reference" hide-details outlined dense :disabled="!hasUserGotRoles(['telco-provisioning'])" />
          </v-col>
        </v-row>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <VSpacer></VSpacer>
        <VBtn color="primary" small @click="submit" :disabled="disableSubmit" :loading="getIsTelcoProvisioningLoading">Save</VBtn>
        <VBtn color="primary" small outlined @click="close" :disabled="getIsTelcoProvisioningLoading">Close</VBtn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
  import { mapGetters,mapActions } from 'vuex';
  import DateSelect from '@/components/Globals/DateSelect.vue';

  export default {

    components: {DateSelect},
    
    props: ['dialogOpen'],

    data() {
      return {
        formData: {
          expected_live_date: '',
          automated: true,
          new_line: false,
          auto_number: false,
          keep_existing_number: false,
          line_to_be_taken_over: '',
          old_line_postcode: '',
          order_type: '',
          line_supplier: '',
          broadband_supplier: '',
          two_stage: false,
          second_stage_live_date: '',
          installation_appt_preferred_window: '',
          installation_appt_date: '',
          installation_appt_ref: '',
          installation_appt: false,
        },
        lineSuppliers: [{text:'None',value:'None'},{text:'TTB',value:'TALK_TALK'},{text:'BT',value:'OPEN_REACH'}],
        broadbandSuppliers: [{text:'None',value:'None'},{text:'TTB',value:'TALK_TALK'},{text:'BTW',value:'BTW'},{text:'Wavenet',value:'Wavenet'}, {text:'Jola - 3',value:'Jola - 3'}, {text:'Jola - EE',value:'Jola - EE'}],
        appointmentTimes: [{text:'AM',value:'AM'},{text:'PM',value:'PM'}],
      }
    },

    computed: {
      ...mapGetters('products',['getCurrentProduct']),
      ...mapGetters('productTelco',['getTelcoProvisioning','getIsTelcoProvisioningLoading', 'getTelcoOrderTypes', 'getFetchTelcoOrderTypesLoading']),
      ...mapGetters("globals", ['hasUserGotRoles']),
      
      isNotConfirmedOrUpgrade(){
        let cp = this.getCurrentProduct;
        return !(cp.confirmed_date===null||cp.upgrade_status==='UPGRADE_IN_PROGRESS'||cp.status==='Upgrade');
      },

      disableSubmit(){
        return this.getIsTelcoProvisioningLoading;
      },

    },
    watch: {
      dialogOpen(opened) {
        if(opened){
          this.fetchTelcoOrderTypes();
          
          this.formData.new_line = this.getTelcoProvisioning.new_line;
          this.formData.auto_number = this.getTelcoProvisioning.auto_number;
          this.formData.keep_existing_number = this.getTelcoProvisioning.new_line_existing_number;
          this.formData.order_type = this.getTelcoProvisioning.order_type;
          this.formData.line_supplier = this.getTelcoProvisioning.line_supplier;
          this.formData.broadband_supplier = this.getTelcoProvisioning.broadband_supplier;
          this.formData.line_to_be_taken_over = this.getTelcoProvisioning.new_line_number;
          this.formData.old_line_postcode = this.getTelcoProvisioning.old_line_post_code;
          this.formData.expected_live_date = this.getTelcoProvisioning.expected_live_date;
          this.formData.two_stage = this.getTelcoProvisioning.two_stage || false;
          this.formData.second_stage_live_date = this.getTelcoProvisioning.second_stage_live_date;
          this.formData.installation_appt_preferred_window = this.getTelcoProvisioning.installation_appt_preferred_window;
          this.formData.installation_appt_date = this.getTelcoProvisioning.installation_appt_date;
          this.formData.installation_appt_ref = this.getTelcoProvisioning.installation_appt_ref;
          this.formData.installation_appt = this.getTelcoProvisioning.installation_appt;
          this.formData.automated = this.getTelcoProvisioning.automated;
        }
      }
    },

    methods: {
      ...mapActions('productTelco',['updateTelcoProvisioning', 'fetchTelcoOrderTypes']),

      async submit() {
        let postData = {
          new_line: this.formData.new_line,
          auto_number: this.formData.auto_number,
          new_line_existing_number: this.formData.keep_existing_number,
          order_type: this.formData.order_type,
          line_supplier: this.formData.line_supplier,
          broadband_supplier: this.formData.broadband_supplier,
          new_line_number: this.formData.line_to_be_taken_over || '',
          old_line_post_code: this.formData.old_line_postcode,
          expected_live_date: this.formData.expected_live_date ? this.formData.expected_live_date : null,
          two_stage: this.formData.two_stage,
          second_stage_live_date: this.formData.second_stage_live_date ? this.formData.second_stage_live_date : null,
          installation_appt_preferred_window: this.formData.installation_appt_preferred_window,
          installation_appt_date: this.formData.installation_appt_date ? this.formData.installation_appt_date : null,
          installation_appt_ref: this.formData.installation_appt_ref,
          installation_appt: this.formData.installation_appt,
          automated: this.formData.automated,
        }
        let success = await this.updateTelcoProvisioning({pid:this.getCurrentProduct.id,data:postData});
        if(success){ this.close(); }
      },

      close() {
        this.formData = {
          expected_live_date: '',
          automated: true,
          new_line: false,
          auto_number: false,
          keep_existing_number: false,
          line_to_be_taken_over: '',
          old_line_postcode: '',
          order_type: '',
          line_supplier: '',
          broadband_supplier: '',
          two_stage: false,
          second_stage_live_date: '',
          installation_appt_preferred_window: '',
          installation_appt_date: '',
          installation_appt_ref: '',
          installation_appt: false,
        };
        this.$emit('close-dialog');
      },
    },

  }
</script>

<style lang="scss" scoped></style>
